import styled from "styled-components";

export const ModalTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral["900"]};
`;

export const ModalContent = styled.div`
  position: relative;
  max-height: 520px;
  overflow-y: auto;
`;

export const SlotTitle = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["700"]};
`;

export const SlotStartDateAndTeacherNameContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const SlotTeacherName = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[500]};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const SlotDateAndTime = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: 700;
  margin: 0;
`;

export const SelectedSlotWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0 12px 0;
`;

export const SelectedSlotCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  gap: 20px;
`;

export const Divider = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.neutral["200"]};
`;

export const VerticalDivider = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  height: 12px;
  margin: 0 4px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  button {
    width: 300px;
  }
  background-color: ${({ theme }) => theme.colors.white};
  position: sticky;
  bottom: 0;
  z-index: 1;
`;

export const ClassTypeWrapper = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ClassTypeTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
`;

export const ClassTypeDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
`;
